Customer.Users ||= {}

class Customer.Users.AppleAppStoreProfileView extends Backbone.View

  template: JST["backbone/templates/customer/users/apple_app_store_profile"]

  className: 'social-profile'
  id: 'apple_app_store-profile'

  events:
    'click .remove-profile-button': 'removeSocialUser'

  initialize: (socialUser) ->
    @socialUser = socialUser

  render: ->
    @$el.html(@template(socialUser: @socialUser))
    @

  removeSocialUser: ->
    @trigger('profile:remove-social-user', @socialUser)